<template>
  <require-access :data="statsAbac.data" :action="statsAbac.action">
    <div
      class="transactions-statistic transactions-statistic__group--statistic"
    >
      <div class="transactions-statistic__item transactions-statistic__total">
        <div class="transactions-statistic__item-title">
          {{ $t('analytics.stats.global.count') }}:
        </div>
        <div class="transactions-statistic__item-value">
          {{ currentStats.count || 0 }}
        </div>
      </div>
      <div class="transactions-statistic__item transactions-statistic__amount">
        <div class="transactions-statistic__item-title">
          {{ $t('analytics.stats.global.amount') }}:
        </div>
        <div class="transactions-statistic__item-value">
          {{ currentStats.sum || 0 }} {{ currentStats.currency }}
        </div>
      </div>
      <div
        class="transactions-statistic__toggle"
        :class="{ rotated: isStatisticOpened }"
        v-if="hasStats"
        @click="toggleStatistic"
      >
        <svg
          width="26"
          height="26"
          viewBox="0 0 26 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="25"
            height="25"
            rx="8.5"
            transform="matrix(0 1 1 0 0 0)"
            stroke="#E0E6F2"
          />
          <path
            d="M12.6491 15.5243L9.12646 12.0016C9.04492 11.9201 9 11.8114 9 11.6954C9 11.5794 9.04492 11.4706 9.12646 11.3892L9.38582 11.1297C9.55483 10.9609 9.8295 10.9609 9.99825 11.1297L12.9564 14.0879L15.9178 11.1265C15.9993 11.045 16.108 11 16.2239 11C16.34 11 16.4487 11.045 16.5303 11.1265L16.7896 11.3859C16.8711 11.4674 16.916 11.5761 16.916 11.6921C16.916 11.8081 16.8711 11.9168 16.7896 11.9983L13.2637 15.5243C13.1819 15.606 13.0727 15.6509 12.9566 15.6506C12.84 15.6509 12.7309 15.606 12.6491 15.5243Z"
            fill="#666D79"
          />
        </svg>
      </div>
    </div>
  </require-access>
</template>

<script>
import {
  $on,
  $off,
  $once,
  $emit,
} from '../../../../../../../utils/gogocodeTransfer'
import RequireAccess from '@vue-app/components/base/role-based/RequireAccess.vue'
import { Stats } from '@js-app/entities/transaction/Stats'

export default {
  name: 'StatsBlock',
  components: { RequireAccess },
  props: {
    statsAbac: {
      type: Object,
    },

    bills: {
      type: Boolean,
      default: false,
    },

    stats: {
      type: [Stats, Object],
      default() {
        return new Stats()
      },
    },
    isStatisticOpened: {
      type: Boolean,
    },
    hasStats: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    currentStats() {
      const stats = this.bills
        ? this.stats.getPlainStats()
        : this.stats.allStats

      if (stats?.currency === null || undefined) {
        stats.currency = 'UAH'
      }

      if (stats?.count === null || undefined) {
        stats.count = 0
      }

      if (stats?.sum === null || undefined) {
        stats.sum = 0
      }

      return stats
    },
  },
  methods: {
    toggleStatistic() {
      $emit(this, 'toggleStatistic')
    },
  },
  emits: ['toggleStatistic'],
}
</script>

<style lang="scss" scoped>
.transactions-statistic {
  padding: 7px 15px 9px 24px;
  background: #ffffff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  &__item {
    display: flex;
    align-items: center;
    margin-left: 60px;

    &:first-child {
      margin-left: 0;
    }

    &-title {
      font-weight: 500;
      font-size: 12px;
      line-height: 28px;
      color: #909cb0;
      margin-right: 10px;
    }

    &-value {
      font-weight: 600;
      font-size: 12px;
      line-height: 28px;
      color: #47475e;
    }
  }

  &__toggle {
    margin-left: 15px;
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &.rotated {
      transform: rotate(180deg);
    }

    &:hover {
      opacity: 0.8;
    }

    svg {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
